import React, { useState } from 'react';
import styled from 'styled-components';
import { strings } from '/imports/strings';
import { Button } from '/imports/ui/Button';
import { Modal, ModalProps } from '/imports/ui/Modal';
import { Form } from '/imports/ui/Form';
import { toastOnError } from '/imports/ui/utils';
import { FormField } from '/imports/ui/FormField';
import { DateTimeInput } from '/imports/ui/DateTimeInput';
import { exportProductionIntervals } from '/imports/api/productionIntervals';
import { Checkbox } from '/imports/ui/Checkbox';
import { clientDownloadUrl } from '/imports/utils';
import { Loading } from '/imports/ui/Loading';

const ExportProductionIntervalsModalStyled = styled(Modal)`
  .timezone {
    padding: 1rem 0;
  }
  .modal-title {
    font-size: 1.5rem;
  }
  .option-buttons {
    display: flex;
    justify-content: center;
    gap: 1rem;
  }
  input {
    display: inline-block;
    &:not([type=checkbox]) {
      width: auto;
    }
    margin-right: 1rem;
  }
`;

interface ExportProductionIntervalsModalProps {
  meterIds: string[];
  onClose: ModalProps['onClose'];
}

/** Modal for exporting production interval data to XLSX over a date range. */
export const ExportProductionIntervalsModal = (props: ExportProductionIntervalsModalProps) => {
  const meterIds = props.meterIds;
  const [from, setFrom] = useState<Date>();
  const [to, setTo] = useState<Date>();
  const [tz, setTz] = useState<string>();
  const [exporting, setExporting] = useState(false);
  const submit = toastOnError(async () => {
    if (!meterIds?.length || !from || !to) return;
    setExporting(true);
    const fileUrl = await exportProductionIntervals.call({ meterIds, from, to });
    const fileName = 'Production-Export.xlsx';
    clientDownloadUrl(fileUrl, fileName);
    setExporting(false);
  });
  return (
    <ExportProductionIntervalsModalStyled
      title={strings.ExportProduction()}
      onClose={props.onClose}
    >
      <Form onSubmit={submit}>
        <div className="field-group">
          <FormField field="from">
            <label>{strings.From()}</label>
            <DateTimeInput id="export-prod-from" value={from} onChange={(from) => setFrom(from)} step="900" />
          </FormField>
        </div>
        <div className="field-group">
          <FormField field="to">
            <label>{strings.To()}</label>
            <DateTimeInput id="export-prod-to" value={to} onChange={(to) => setTo(to)} step="900" />
          </FormField>
        </div>
        <div className="field-group">
          <FormField field="tz" className="checkbox">
            <label>
              <Checkbox
                id="export-prod-utc"
                checked={tz === 'UTC'}
                onChange={(checked) => checked ? setTz('UTC') : setTz(undefined)}
              />
              {strings.UseUtcFormat()}
            </label>
          </FormField>
        </div>
        <div className="buttons">
          <Button id="export-prod-btn" type="submit" disabled={!meterIds[0] || !from || !to || exporting}>{exporting ? <Loading /> :strings.ExportProduction()}</Button>
        </div>
      </Form>
    </ExportProductionIntervalsModalStyled>
  );
};